<script>
export default {
  props: {
    show: Boolean,
    result: {
      type: Object,
      default: () => ({ success: [], failed: [] }),
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Detail Data Gagal Import"
    size="lg"
    hide-footer
  >
    <p class="mb-2">
      <strong>{{ result.success.length }}</strong> baris berhasil diimport,
      <strong>{{ result.failed.length }}</strong> baris gagal diimport.
    </p>

    <div class="table-responsive">
      <table class="table table-sm table-bordered mb-0">
        <thead>
          <tr>
            <th width="60px">Row</th>
            <th width="120px">NIP Atasan</th>
            <th width="120px">NIP Pegawai</th>
            <th width="160px">Nama Pegawai</th>
            <th>Pesan Gagal</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in result.failed" :key="index">
            <td>{{ item.row }}</td>
            <td>{{ item.nip_atasan }}</td>
            <td>{{ item.nip_pegawai }}</td>
            <td>{{ item.nama_pegawai }}</td>
            <td>{{ item.message }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-end mt-3">
      <b-button variant="secondary" @click="$emit('close')">
        Tutup
      </b-button>
    </div>
  </b-modal>
</template>
